import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { useMobxInstance } from '../clientUtils/mobxUtil';
import firebaseStore from '../stores/firebaseStore';
import modalStore from '../stores/modalStore';
import { useCommonNavigate } from '../views/common/CommonLink';
import ListeningHeader from './ListeningHeader';
import _ from 'lodash';

class ViewStore {
    constructor() {
        makeAutoObservable(this);
    }
}

const CtaButton = observer(
    ({
        viewStore,
        navigate,
        className,
    }: {
        viewStore: ViewStore;
        navigate: (to: string) => void;
        className?: string;
    }) => {
        return (
            <button
                className={twMerge('btn btn-primary btn-lg rounded-full px-10', className)}
                onClick={async (e) => {
                    e.preventDefault();

                    if (!firebaseStore.isInitialized) {
                        return;
                    }

                    if (firebaseStore.me) {
                        navigate('/dashboard');
                        return;
                    }

                    // 로그인 모달 표시
                    const { returnValue } = await modalStore.login();
                    if (returnValue) {
                        // 로그인 모달이 닫히고 난 후에 이동하도록 딜레이를 줌
                        _.delay(() => {
                            navigate('/dashboard');
                        }, 500);
                    }
                }}
            >
                무료로 시작하기
            </button>
        );
    },
);

const ListeningHomePage = observer(() => {
    const viewStore = useMobxInstance(ViewStore);
    const { navigate } = useCommonNavigate();

    useEffect(() => {
        (async () => {
            // 로그인 되어있다면 바로 대시보드로 이동
            // firebaseStore.me 로 처리하면 로그인 모달이 닫히는 타이밍과 맞지 않아서 마운트 되었을 때 한 번만 이동처리함
            const isLoggedIn = await firebaseStore.isLoggedIn();
            if (isLoggedIn) {
                navigate('/dashboard');
            }
        })();
    }, []);

    return (
        <div>
            <ListeningHeader />
            <div className="mx-auto w-full max-w-[760px] px-4">
                {/* 히어로 섹션 */}
                <section className="flex flex-col items-center py-20 text-center">
                    <h1 className="text-base-content mb-4 text-3xl leading-tight font-bold md:text-4xl">
                        좋아하는 영상으로
                        <br />
                        영어 듣기 실력을 키워보세요
                    </h1>
                    <p className="text-base-content/60 mb-8 text-lg">
                        유튜브 영상을 나만의 듣기 레슨으로 만들어 학습하세요
                    </p>
                    <CtaButton viewStore={viewStore} navigate={navigate} />
                </section>

                {/* 서비스 소개 영상 섹션 */}
                <section className="py-10">
                    <div className="bg-base-200 flex aspect-video w-full items-center justify-center rounded-xl">
                        <p className="text-base-content/40">서비스 소개 영상</p>
                    </div>
                </section>

                {/* 두 번째 CTA */}
                <section className="flex flex-col items-center py-10">
                    <CtaButton viewStore={viewStore} navigate={navigate} />
                </section>

                {/* 부가 정보 섹션 */}
                <section className="py-10">{/* TODO: 기능 소개, 사용법 등 추가 */}</section>
            </div>
        </div>
    );
});

export default ListeningHomePage;
